import React from 'react';
import PropTypes from 'prop-types';

import "./RoundCheckbox.scss";

const RoundCheckbox = ({ onClick, isSelected }) => {
  return (
    <button className="button" type="button" onClick={onClick}>
      <div className="round-checkbox">
        {isSelected && <div className="round-checkbox__inner-circle" />}
      </div>
    </button>
  );
};

RoundCheckbox.propTypes = {
  isSelected: PropTypes.bool,
  onClick: PropTypes.func
};

RoundCheckbox.defaultProps = {
  isSelected: false,
  onClick: ()=> {}
};

export default RoundCheckbox;